<template>
   <b-modal
      @hidden="hidden"
      id="modal-assign-vendor"
      size="lg"
      centered
      ref="assignVendorModal"
      header-class="font-weight-normal mx-4"
      body-class="mx-4 body-class"
      dialog-class="modal-assign-vendor"
      @close="closeModal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
   >
      <template #modal-title>
         <h5
            style="
               font-weight: 600;
               margin-bottom: 10px;
               margin-left: 0;
               color: black;
               font-size: 1.15rem;
            "
         >
            {{
               modalState === 'assignVendor' ? `Assign ${entityLabelPlural}` : 'Invite Another User'
            }}
         </h5>
      </template>
      <hr class="footer-full-width-line" />
      <p class="mb-4 mt-2 modal-subtitle">
         <slot>
            {{
               modalState === 'assignVendor'
                  ? `Please assign each ${entityLabelSingularLower} to someone who is able to provide their R&D contributions. Choose an Onboard user from the dropdown below. If the person doesn't have an Onboard account yet, you can create an account for them with the Invite User button. They will be notified of their new account and be able to provide R&D information only for their assignments.`
                  : 'Invite someone else in your organization to help you enter information in this section.'
            }}
         </slot>
      </p>
      <b-row v-if="modalState === 'assignVendor'" class="mb-3 mt-2" style="font-size: 13px">
         <b-col cols="6">
            <b-form-group
               :label="`Assign ${entityLabelPluralLower} to:`"
               label-for="input-user"
               label-class="font-weight-bold"
            >
               <b-form-select
                  id="select-user"
                  v-model="selectedUserId"
                  style="font-size: 13px"
                  class="font-weight-normal"
                  @change="setSelectedUser"
               >
                  <template #first>
                     <b-form-select-option :value="null" disabled id="input-user">
                        Select a User
                     </b-form-select-option>
                  </template>
                  <b-form-select-option
                     v-for="user in sortedUsers"
                     :key="`${user.id}-${user.firstName}`"
                     :value="user.id"
                     :disabled="selectedUserId == user.id"
                  >
                     {{ formatUserName(user, profile.id) }}
                  </b-form-select-option>
               </b-form-select>
            </b-form-group>
         </b-col>
         <b-col
            cols="6"
            class="d-flex justify-content-end align-items-center"
            style="margin-bottom: -7px"
         >
            <b-button
               variant="primary"
               style="font-size: 12px; padding: 5px 20px; height: 30px; background-color: #0978cd"
               @click="changeState()"
               v-if="!isSME"
            >
               Invite User +
            </b-button>
         </b-col>
      </b-row>
      <b-row v-if="modalState === 'assignVendor' && selectedUserId" class="mb-3">
         <b-col cols="12" v-if="showAssignmentPermissionWarning" class="mb-2">
            <b-alert show variant="warning" class="mb-0 py-2 permission-warning-alert">
               {{ assignmentWarningText }}
            </b-alert>
         </b-col>
         <b-col cols="6" style="border-right: 1px solid lightgray; padding-right: 30px">
            <label style="font-size: 16px; color: black" class="font-weight-bold"
               >Unassigned {{ entityLabelPlural }}</label
            >

            <b-input-group class="mb-2">
               <b-form-input
                  v-model="unassignedFilters.search"
                  :placeholder="`Search for a ${entityLabelSingularLower}`"
                  @update="() => (unassignedList = [])"
                  style="
                     font-size: 13px;
                     border-top-right-radius: 8px;
                     border-bottom-right-radius: 8px;
                  "
                  class="font-weight-normal"
               ></b-form-input>
               <b-input-group-append
                  :is-text="true"
                  style="
                     background-color: white;
                     color: lightgray;
                     position: absolute;
                     right: 4px;
                     top: 2px;
                     height: 30px;
                  "
               >
                  <b-icon-search></b-icon-search>
               </b-input-group-append>
            </b-input-group>

            <b-form-row v-if="!isContractors" class="mb-2">
               <b-col class="d-flex align-items-center">
                  <img
                     src="@/assets/img/filters.png"
                     alt="filters"
                     style="width: 25px"
                     class="mr-1"
                  />
                  <b-form-select
                     size="sm"
                     :options="unassignedAccountsFilterOptions"
                     v-model="unassignedFilters.accounts"
                     @change="() => (unassignedList = [])"
                     style="font-size: 13px; height: 35px"
                     class="font-weight-normal"
                  >
                     <template #first>
                        <b-form-select-option
                           :value="null"
                           style="font-size: 13px"
                           class="font-weight-normal"
                        >
                           All Accounts
                        </b-form-select-option>
                     </template>
                  </b-form-select>
                  <b-form-select
                     v-if="expenseType === 'employees' && unassignedTitleFilterOptions.length > 0"
                     size="sm"
                     :options="unassignedTitleFilterOptions"
                     v-model="unassignedFilters.title"
                     @change="() => (unassignedList = [])"
                     style="font-size: 13px; height: 35px"
                     class="font-weight-normal ml-2"
                  >
                     <template #first>
                        <b-form-select-option
                           :value="null"
                           style="font-size: 13px"
                           class="font-weight-normal"
                        >
                           All Job Titles
                        </b-form-select-option>
                     </template>
                  </b-form-select>
                  <b-form-select
                     v-if="
                        expenseType === 'employees' && unassignedDepartmentFilterOptions.length > 0
                     "
                     size="sm"
                     :options="unassignedDepartmentFilterOptions"
                     v-model="unassignedFilters.department"
                     @change="() => (unassignedList = [])"
                     style="font-size: 13px; height: 35px"
                     class="font-weight-normal ml-2"
                  >
                     <template #first>
                        <b-form-select-option
                           :value="null"
                           style="font-size: 13px"
                           class="font-weight-normal"
                        >
                           All Departments
                        </b-form-select-option>
                     </template>
                  </b-form-select>
               </b-col>
            </b-form-row>

            <div class="table mt-3" v-if="filteredUnassignedVendorSets.length > 0">
               <b-form-checkbox
                  :checked="isUnassignedAllSelected"
                  @change="unassignedToggleAll"
                  style="position: relative; left: 10px; bottom: 2px"
               />

               <div class="custom-body">
                  <div
                     v-for="vendor in filteredUnassignedVendorSets"
                     :key="
                        vendor.name
                           ? `${vendor.name}-${vendor.vendorId || vendor.id}`
                           : `${vendor.vendor}-${vendor.vendorId || vendor.id}`
                     "
                     class="vendor-row"
                     :class="{'vendor-row-disabled': isAssignmentLockedVendor(vendor)}"
                     @click="toggleVendorSelection(vendor, unassignedList, $event)"
                  >
                     <b-form-checkbox
                        :checked="isVendorChecked(vendor, unassignedList)"
                        :disabled="isAssignmentLockedVendor(vendor)"
                        @change="toggleVendorSelection(vendor, unassignedList)"
                     ></b-form-checkbox>
                     <div style="display: flex; flex-direction: column; font-size: 13px">
                        <span>
                           <strong>{{ vendor.name ? vendor.name : vendor.vendor }} </strong>
                        </span>
                        <small class="text-muted">
                           <template v-if="expenseType === 'employees'">
                              {{ [vendor.title, vendor.department].filter(Boolean).join(' | ') }}
                           </template>
                           <template v-else>
                              {{ vendor.account ? vendor.account : '' }}
                              {{
                                 vendor.location && declaration === 'MANY'
                                    ? `${usStates[vendor.location]}`
                                    : ''
                              }}
                           </template>
                        </small>
                        <small v-if="isAssignmentLockedVendor(vendor)" class="vendor-lock-note">
                           Not eligible for assignment
                        </small>
                     </div>
                  </div>
               </div>
               <div
                  class="d-flex justify-content-end mt-2"
                  v-if="filteredUnassignedVendorSets.length > 0"
               >
                  <b-button
                     id="btn-assign-employees"
                     variant="primary"
                     class="action-button"
                     @click="assignVendors"
                     :disabled="
                        unassignedList.length === 0 ||
                        !selectedUser ||
                        !hasEligibleUnassignedSelection ||
                        doAssignments
                     "
                  >
                     <b-icon-arrow-right style="margin-right: 5px"></b-icon-arrow-right>
                     Assign to
                     {{
                        selectedUser
                           ? selectedUser.id === profile.id
                              ? 'Me'
                              : `${selectedUser.firstName} ${selectedUser.lastName}`
                           : ' '
                     }}
                  </b-button>
               </div>
            </div>
         </b-col>

         <b-col cols="6" style="padding-left: 30px">
            <label style="font-size: 16px; color: black" class="font-weight-bold">
               Assigned to
               {{
                  selectedUser
                     ? selectedUser.id == profile.id
                        ? 'Me'
                        : `${selectedUser.firstName} ${selectedUser.lastName}`
                     : ' '
               }}</label
            >

            <div>
               <b-input-group class="mb-2">
                  <b-form-input
                     v-model="assignedFilters.search"
                     @update="() => (assignedList = [])"
                     :placeholder="`Search for a ${entityLabelSingularLower}`"
                     style="
                        font-size: 13px;
                        border-top-right-radius: 8px;
                        border-bottom-right-radius: 8px;
                     "
                     class="font-weight-normal"
                  ></b-form-input>
                  <b-input-group-append
                     :is-text="true"
                     style="
                        background-color: white;
                        color: lightgray;
                        position: absolute;
                        right: 4px;
                        top: 2px;
                        height: 30px;
                     "
                  >
                     <b-icon-search></b-icon-search>
                  </b-input-group-append>
               </b-input-group>

               <b-form-row v-if="!isContractors" class="mb-2">
                  <b-col class="d-flex align-items-center">
                     <img
                        src="@/assets/img/filters.png"
                        alt="filters"
                        style="width: 25px"
                        class="mr-1"
                     />
                     <b-form-select
                        size="sm"
                        :options="assignedAccountsFilterOptions"
                        v-model="assignedFilters.accounts"
                        @change="() => (assignedList = [])"
                        style="font-size: 13px; height: 35px"
                        class="font-weight-normal"
                     >
                        <template #first>
                           <b-form-select-option
                              :value="null"
                              style="font-size: 13px"
                              class="font-weight-normal"
                           >
                              All Accounts
                           </b-form-select-option>
                        </template>
                     </b-form-select>
                     <b-form-select
                        v-if="expenseType === 'employees' && assignedTitleFilterOptions.length > 0"
                        size="sm"
                        :options="assignedTitleFilterOptions"
                        v-model="assignedFilters.title"
                        @change="() => (assignedList = [])"
                        style="font-size: 13px; height: 35px"
                        class="font-weight-normal ml-2"
                     >
                        <template #first>
                           <b-form-select-option
                              :value="null"
                              style="font-size: 13px"
                              class="font-weight-normal"
                           >
                              All Job Titles
                           </b-form-select-option>
                        </template>
                     </b-form-select>
                     <b-form-select
                        v-if="
                           expenseType === 'employees' && assignedDepartmentFilterOptions.length > 0
                        "
                        size="sm"
                        :options="assignedDepartmentFilterOptions"
                        v-model="assignedFilters.department"
                        @change="() => (assignedList = [])"
                        style="font-size: 13px; height: 35px"
                        class="font-weight-normal ml-2"
                     >
                        <template #first>
                           <b-form-select-option
                              :value="null"
                              style="font-size: 13px"
                              class="font-weight-normal"
                           >
                              All Departments
                           </b-form-select-option>
                        </template>
                     </b-form-select>
                  </b-col>
               </b-form-row>
            </div>

            <div class="table mt-3" v-if="filteredAssignedVendorSets.length > 0">
               <b-form-checkbox
                  :checked="isAllSelected"
                  @change="toggleAll"
                  style="position: relative; left: 10px; bottom: 2px"
               />

               <div class="custom-body">
                  <div
                     v-for="vendor in filteredAssignedVendorSets"
                     :key="
                        vendor.name
                           ? `${vendor.name}-${vendor.vendorId || vendor.id}`
                           : `${vendor.vendor}-${vendor.vendorId || vendor.id}`
                     "
                     class="vendor-row"
                     :class="{'vendor-row-disabled': !canUnassignVendor(vendor)}"
                     @click="toggleVendorSelection(vendor, assignedList, $event)"
                  >
                     <b-form-checkbox
                        :checked="isVendorChecked(vendor, assignedList)"
                        :disabled="!canUnassignVendor(vendor)"
                        @change="toggleVendorSelection(vendor, assignedList)"
                     ></b-form-checkbox>
                     <div style="display: flex; flex-direction: column; font-size: 13px">
                        <span>
                           <strong>{{ vendor.name ? vendor.name : vendor.vendor }} </strong>
                        </span>
                        <small class="text-muted">
                           <template v-if="expenseType === 'employees'">
                              {{ [vendor.title, vendor.department].filter(Boolean).join(' | ') }}
                           </template>
                           <template v-else>
                              {{ vendor.account ? vendor.account : '' }}
                              {{
                                 vendor.location && declaration === 'MANY'
                                    ? `${usStates[vendor.location]}`
                                    : ''
                              }}
                           </template>
                        </small>
                        <small v-if="isAssignmentLockedVendor(vendor)" class="vendor-lock-note">
                           Not eligible for assignment
                        </small>
                     </div>
                  </div>
               </div>
               <div
                  class="d-flex justify-content-start mt-2"
                  v-if="filteredAssignedVendorSets.length > 0"
               >
                  <b-button
                     id="btn-unassign-employees"
                     variant="primary"
                     class="action-button"
                     @click="unassignVendors"
                     :disabled="assignedList.length === 0 || !selectedUser"
                  >
                     <b-icon-arrow-left style="margin-right: 5px"></b-icon-arrow-left>
                     Unassign
                  </b-button>
               </div>
            </div>
         </b-col>
      </b-row>
      <b-row v-if="modalState === 'inviteUser'">
         <InviteUser @cancel-action="cancelAction" @submit-action="submitAction" />
      </b-row>
   </b-modal>
</template>

<script>
import {mapGetters} from 'vuex';
import {clientUserSuggestions} from '@/mixins';
import InviteUser from '@/components/forms/InviteUser.vue';
import {EXPENSE_ENTITY_LABEL_CONFIG} from '@/helpers/baseConfig';
import {hasContractorPaymentsPermission, hasEmployeePayrollPermission} from '@/helpers/utils';
import {getManualVendorId} from '@/store/utils/expense-data-identity';

export default {
   components: {
      InviteUser,
   },

   mixins: [
      // Adds support for department/job title suggestions
      clientUserSuggestions,
   ],

   props: {
      expenseType: {
         type: String,
         required: true,
         validator: (value) => ['cloud', 'supplies', 'contractors', 'employees'].includes(value),
      },
   },
   data() {
      return {
         modalState: 'assignVendor',
         assignedList: [],
         unassignedList: [],
         loaded: false,
         doAssignments: false,
         selectedUser: null,
         selectedUserId: null,
         unassignedFilters: {
            accounts: null,
            search: null,
            title: null,
            department: null,
         },
         assignedFilters: {
            accounts: null,
            search: null,
            title: null,
            department: null,
         },
      };
   },

   computed: {
      ...mapGetters({
         profile: 'profile',
         company: 'companies/currentCompany',
         hasOpenStudy: 'companies/hasOpenStudy',
         openStudyPeriods: 'companies/openStudyPeriods',
         activeStudyPeriods: 'companies/activeStudyPeriods',
         activeStudyId: 'companies/activeStudyId',
         studyPeriodMap: 'companies/studyPeriodMap',
         users: 'users/companyUsers',
         isSME: 'isSME',
         usStates: 'usStates',
      }),
      manualVendors() {
         return this.$store.getters[`${this.expenseType}/manualVendors`];
      },
      importedVendors() {
         return this.$store.getters[`${this.expenseType}/importedVendors`];
      },
      declaration() {
         return this.$store.getters[`${this.expenseType}/declaration`];
      },
      adHocData() {
         return this.$store.getters[`${this.expenseType}/adHocData`];
      },
      isContractors() {
         return this.expenseType === 'contractors';
      },
      isEmployees() {
         return this.expenseType === 'employees';
      },
      entityLabelPlural() {
         return (
            EXPENSE_ENTITY_LABEL_CONFIG[this.expenseType]?.plural ||
            EXPENSE_ENTITY_LABEL_CONFIG.supplies.plural
         );
      },
      entityLabelPluralLower() {
         return (
            EXPENSE_ENTITY_LABEL_CONFIG[this.expenseType]?.pluralLower ||
            EXPENSE_ENTITY_LABEL_CONFIG.supplies.pluralLower
         );
      },
      entityLabelSingularLower() {
         return (
            EXPENSE_ENTITY_LABEL_CONFIG[this.expenseType]?.singularLower ||
            EXPENSE_ENTITY_LABEL_CONFIG.supplies.singularLower
         );
      },

      periodId() {
         return this.$route.params.periodId;
      },

      companyId() {
         if (this.$route.params.id) {
            return parseInt(this.$route.params.id);
         } else {
            return this.$companyId;
         }
      },

      normalizedManualVendors() {
         return this.manualVendors.map(
            ({companyId, id, assigneeId, location, studyId, name, title, department}) => ({
               companyId,
               vendorId: id,
               assigneeId,
               location,
               studyId,
               name,
               title,
               department,
            })
         );
      },

      // Unlike contractors/supplies/cloud (whose imported vendors are CSV line-items
      // shaped as {vendor, account, period} needing cross-period consolidation),
      // employees' imported_vendors are the same ManualAddedEmployee entity shape as
      // manual_vendors -- one row per employee, identified by id, named via `fullname`.
      // Normalize them the same way so they take the manual/vendorId path below instead
      // of the account-grouping path, which would blank their label and merge rows.
      normalizedImportedVendors() {
         if (this.expenseType !== 'employees') {
            return this.importedVendors;
         }

         return this.importedVendors.map(
            ({
               companyId,
               id,
               assigneeId,
               location,
               studyId,
               fullname,
               name,
               title,
               department,
               account,
            }) => ({
               companyId,
               vendorId: id,
               assigneeId,
               location,
               account,
               studyId,
               name: fullname ?? name ?? null,
               title,
               department,
            })
         );
      },

      setManualPeriod() {
         return this.activeStudyPeriods[0] ? this.activeStudyPeriods[0] : this.openStudyPeriods[0];
      },

      isAllSelected() {
         return (
            this.filteredEligibleAssignedVendorSets.length > 0 &&
            this.assignedList.length === this.filteredEligibleAssignedVendorSets.length
         );
      },

      isUnassignedAllSelected() {
         return (
            this.filteredEligibleUnassignedVendorSets.length > 0 &&
            this.unassignedList.length === this.filteredEligibleUnassignedVendorSets.length
         );
      },

      unassignedAccountsFilterOptions() {
         return this.accountsFilterOptions(this.unassignedVendorSet, this.unassignedFilters);
      },

      assignedAccountsFilterOptions() {
         return this.accountsFilterOptions(this.assignedVendorSet, this.assignedFilters);
      },

      unassignedTitleFilterOptions() {
         return this.distinctFieldFilterOptions(
            this.unassignedVendorSet,
            this.unassignedFilters,
            'title'
         );
      },

      assignedTitleFilterOptions() {
         return this.distinctFieldFilterOptions(
            this.assignedVendorSet,
            this.assignedFilters,
            'title'
         );
      },

      unassignedDepartmentFilterOptions() {
         return this.distinctFieldFilterOptions(
            this.unassignedVendorSet,
            this.unassignedFilters,
            'department'
         );
      },

      assignedDepartmentFilterOptions() {
         return this.distinctFieldFilterOptions(
            this.assignedVendorSet,
            this.assignedFilters,
            'department'
         );
      },

      sortedUsers() {
         return Object.values(this.users).sort((a, b) => {
            const key = ({lastName, firstName}) => `${lastName}${firstName}`.toUpperCase();
            return key(a).localeCompare(key(b));
         });
      },

      unassignedVendorSet() {
         return this.vendorsByStatus(({assigneeId}) => !assigneeId);
      },

      assignedVendorSet() {
         return this.vendorsByStatus(({assigneeId}) => assigneeId === this.selectedUserId);
      },

      filteredUnassignedVendorSets() {
         return this.transformVendorPeriods(
            this.filterVendorsByStatus(({assigneeId}) => !assigneeId, this.unassignedFilters)
         );
      },

      filteredEligibleUnassignedVendorSets() {
         return this.filteredUnassignedVendorSets.filter(
            (vendor) => !this.isAssignmentLockedVendor(vendor)
         );
      },

      filteredAssignedVendorSets() {
         return this.transformVendorPeriods(
            this.filterVendorsByStatus(
               ({assigneeId}) => assigneeId === this.selectedUserId,
               this.assignedFilters
            )
         );
      },

      filteredEligibleAssignedVendorSets() {
         return this.filteredAssignedVendorSets.filter((vendor) => this.canUnassignVendor(vendor));
      },

      selectedUserHasContractorPaymentsPermission() {
         if (!this.isContractors) {
            return true;
         }

         return this.hasContractorPaymentsPermission(this.selectedUser);
      },

      selectedUserHasEmployeePayrollPermission() {
         if (!this.isEmployees) {
            return true;
         }

         return this.hasEmployeePayrollPermission(this.selectedUser);
      },

      showContractorPaymentsWarning() {
         return (
            this.isContractors &&
            !!this.selectedUser &&
            !this.selectedUserHasContractorPaymentsPermission &&
            [...this.filteredUnassignedVendorSets, ...this.filteredAssignedVendorSets].some(
               (vendor) => this.isAssignmentLockedVendor(vendor)
            )
         );
      },

      showEmployeePayrollWarning() {
         return (
            this.isEmployees &&
            !!this.selectedUser &&
            !this.selectedUserHasEmployeePayrollPermission &&
            [...this.filteredUnassignedVendorSets, ...this.filteredAssignedVendorSets].some(
               (vendor) => this.isAssignmentLockedVendor(vendor)
            )
         );
      },

      showAssignmentPermissionWarning() {
         return this.showContractorPaymentsWarning || this.showEmployeePayrollWarning;
      },

      assignmentWarningText() {
         if (this.isEmployees) {
            return `${this.assignmentWarningTarget} does not have permission to see employee taxable wages. Fill out employee taxable wages before assigning.`;
         }

         return `${this.assignmentWarningTarget} does not have permission to see payment info. Fill out payment info before assigning.`;
      },

      assignmentWarningTarget() {
         if (!this.selectedUser) {
            return 'this user';
         }

         if (this.selectedUser.id === this.profile.id) {
            return 'you';
         }

         return `${this.selectedUser.firstName} ${this.selectedUser.lastName}`;
      },

      hasEligibleUnassignedSelection() {
         return this.unassignedList.some((vendor) => this.canAssignVendor(vendor));
      },
   },

   methods: {
      hasContractorPaymentsPermission,
      hasEmployeePayrollPermission,

      getContractorPeriodRows(vendor) {
         if (!this.isContractors || !vendor?.vendorId) {
            return [];
         }

         return Object.values(this.adHocData || {}).flatMap((periodRows) =>
            (periodRows || []).filter((row) => {
               const rowVendorId = row.contractorId ?? row.vendorId;
               return rowVendorId === vendor.vendorId && row.location === vendor.location;
            })
         );
      },

      getEmployeePeriodRows(vendor) {
         if (!this.isEmployees || !vendor?.vendorId) {
            return [];
         }

         return Object.values(this.adHocData || {}).flatMap((periodRows) =>
            (periodRows || []).filter(
               (row) => getManualVendorId(row) === vendor.vendorId && row.id !== null
            )
         );
      },

      isAssignmentLockedVendor(vendor) {
         if (this.isContractors && this.selectedUserHasContractorPaymentsPermission) {
            return false;
         }

         if (this.isEmployees && this.selectedUserHasEmployeePayrollPermission) {
            return false;
         }

         if (this.isContractors) {
            const periodRows = this.getContractorPeriodRows(vendor);
            if (!periodRows.length) {
               return true;
            }

            return periodRows.some((row) => row.assignable !== true);
         }

         if (this.isEmployees) {
            const periodRows = this.getEmployeePeriodRows(vendor);
            if (!periodRows.length) {
               return true;
            }

            return periodRows.some(
               (row) => row.totalDebit === null || row.totalDebit === undefined
            );
         }

         return false;
      },

      canAssignVendor(vendor) {
         return !this.isAssignmentLockedVendor(vendor);
      },

      canUnassignVendor(vendor) {
         if (!this.isAssignmentLockedVendor(vendor)) {
            return true;
         }

         if (!this.isSME) {
            return true;
         }

         return this.selectedUser?.id === this.profile.id;
      },

      transformVendorPeriods(data) {
         const vendorMap = new Map();

         // Group by vendor, keeping other fields from first entry
         data.forEach((item) => {
            if (item.vendorId) {
               const manualKey = `${item.vendorId}_${item.location}_${item.studyId}`;
               vendorMap.set(manualKey, item);
            } else {
               const key = `${item.vendor}_${item.location}_${item.studyId}_${item.account}`;
               if (!vendorMap.has(key)) {
                  vendorMap.set(key, {
                     companyId: item.companyId,
                     assigneeId: item.assigneeId,
                     uploadFileId: item.uploadFileId,
                     location: item.location,
                     id: key,
                     studyId: item.studyId,
                     vendor: item.vendor,
                     account: item.account,
                     iterators: [],
                  });
               }
               const entry = vendorMap.get(key);

               entry.iterators.push({
                  id: item.id,
                  lower: item.period.lower,
                  upper: item.period.upper,
               });
            }
         });

         return Array.from(vendorMap.values());
      },

      accountsFilterOptions(vendors, activefilter) {
         if (this.isContractors) {
            if (activefilter.accounts !== null) {
               this.$set(activefilter, 'accounts', null);
            }
            return [];
         }

         const newFilterOptions = [
            ...new Set(vendors.filter((item) => item.account).map((item) => item.account)),
            'Manual Vendors',
         ];

         if (!newFilterOptions.includes(activefilter.accounts)) {
            this.$set(activefilter, 'accounts', null);
         }
         return [
            ...new Set(vendors.filter((item) => item.account).map((item) => item.account)),
            'Manual Vendors',
         ];
      },
      // Job Title/Department are employee-only concepts -- unlike the account
      // filter (shared with Supplies/Cloud, disabled only for Contractors), these
      // are always empty/meaningless for every other section, so gate on
      // expenseType directly rather than reusing accountsFilterOptions' shape
      // (which also injects a "Manual Vendors" synthetic option that doesn't
      // apply here -- title/department exist on manual and imported employees
      // alike).
      distinctFieldFilterOptions(vendors, activefilter, fieldKey) {
         if (this.expenseType !== 'employees') {
            if (activefilter[fieldKey] !== null) {
               this.$set(activefilter, fieldKey, null);
            }
            return [];
         }

         const newFilterOptions = [
            ...new Set(vendors.filter((item) => item[fieldKey]).map((item) => item[fieldKey])),
         ];

         if (!newFilterOptions.includes(activefilter[fieldKey])) {
            this.$set(activefilter, fieldKey, null);
         }
         return newFilterOptions;
      },
      vendorsByStatus(statusFn) {
         const manualVendors = Object.values(this.normalizedManualVendors).filter(statusFn);
         const importedVendors = this.isContractors
            ? []
            : Object.values(this.normalizedImportedVendors).filter(statusFn);

         return [...manualVendors, ...importedVendors];
      },
      /** All periods (StudyPeriod objects) this employee has a real summary row on. */
      employeeExistingPeriods(employeeId) {
         return Object.keys(this.adHocData || {})
            .filter((periodId) =>
               (this.adHocData[periodId] || []).some(
                  (row) => row.id !== null && getManualVendorId(row) === employeeId
               )
            )
            .map((periodId) => this.studyPeriodMap[periodId])
            .filter(Boolean);
      },
      filterVendorsByStatus(statusFn, filter) {
         const {accounts, search, title, department} = filter;
         const searchLower = (search || '').toLowerCase().trim();

         const manualVendors = Object.values(this.normalizedManualVendors).filter(statusFn);
         const importedVendors = this.isContractors
            ? []
            : Object.values(this.normalizedImportedVendors).filter(statusFn);

         let filtered = [...manualVendors, ...importedVendors];

         if (accounts) {
            if (accounts === 'Manual Vendors') {
               filtered = manualVendors;
            } else {
               filtered = importedVendors.filter(({account}) => account === accounts);
            }
         }

         if (title) {
            filtered = filtered.filter((item) => item.title === title);
         }

         if (department) {
            filtered = filtered.filter((item) => item.department === department);
         }

         if (searchLower) {
            filtered = filtered.filter(({name, vendor}) => {
               const searchable = (name || vendor || '').toLowerCase();
               return searchable.includes(searchLower);
            });
         }

         return filtered;
      },
      toggleAll(event) {
         if (event) {
            this.assignedList = this.filteredEligibleAssignedVendorSets.map((p) => p) || [];
         } else {
            this.assignedList = [];
         }
      },
      unassignedToggleAll(event) {
         if (event) {
            this.unassignedList = this.filteredEligibleUnassignedVendorSets.map((p) => p) || [];
         } else {
            this.unassignedList = [];
         }
      },
      onVendorChecked(targetVendor, list) {
         if (list === this.unassignedList && !this.canAssignVendor(targetVendor)) {
            return;
         }

         if (list === this.assignedList && !this.canUnassignVendor(targetVendor)) {
            return;
         }

         const {vendorId, id} = targetVendor;
         const index = list.findIndex(
            (vendor) =>
               (vendorId && vendor.vendorId === vendorId) || (!vendorId && vendor.id === id)
         );

         if (index === -1) {
            list.push(targetVendor);
         } else {
            list.splice(index, 1);
         }
      },

      toggleVendorSelection(targetVendor, list, event) {
         if (event) {
            event.preventDefault();
         }

         this.onVendorChecked(targetVendor, list);
      },

      closeModal() {
         this.$refs.assignVendorModal.hide();
      },

      async hidden() {
         this.modalState = 'assignVendor';
         this.selectedUserId = null;
      },

      setSelectedUser(userId) {
         this.selectedUserId = userId;
         this.selectedUser = this.sortedUsers.find((u) => u.id === userId) || null;
         this.unassignedList = this.unassignedList.filter((vendor) => this.canAssignVendor(vendor));
         this.assignedList = this.assignedList.filter((vendor) => this.canUnassignVendor(vendor));
      },

      formatUserName({id, firstName, lastName, title, department}, currentUserProfileId) {
         if (id === currentUserProfileId) return 'Me';

         const base = `${firstName} ${lastName}`;
         const details = this.formatUserDetails({title, department});

         return details ? `${base} ${details}` : base;
      },

      formatUserDetails({title, department}) {
         if (title && department) return `(${title} - ${department})`;
         if (title || department) return `(${title || department})`;
         return '';
      },

      isVendorChecked(targetVendor, list) {
         const {vendorId, id} = targetVendor;

         const index = list.findIndex(
            (vendor) =>
               (vendorId && vendor.vendorId === vendorId) || (!vendorId && vendor.id === id)
         );
         return index !== -1;
      },

      syncSelectionWithVisibleSet(sourceList, visibleSet) {
         const keys = new Set(
            visibleSet.map((vendor) =>
               vendor.vendorId ? `manual:${vendor.vendorId}` : `imported:${vendor.id}`
            )
         );
         return sourceList.filter((vendor) => {
            const key = vendor.vendorId ? `manual:${vendor.vendorId}` : `imported:${vendor.id}`;
            return keys.has(key);
         });
      },

      cancelAction() {
         this.modalState = 'assignVendor';
      },

      async submitAction(user) {
         if (user) {
            try {
               await this.$store.dispatch('users/loadCompanyUsers', {companyId: this.companyId});
               this.setSelectedUser(user.id);
               this.modalState = 'assignVendor';
            } catch (e) {
               console.error(e);
            }
         }
      },

      show() {
         this.$bvModal.show('modal-assign-vendor');
      },

      changeState() {
         this.modalState = 'inviteUser';
      },

      async reloadAssignmentState() {
         await this.$store.dispatch('companies/loadStudyAssignments', {
            companyId: this.companyId,
         });
      },

      /** Submit requests to assign the selected employees to the selected user */
      async assignVendors() {
         if (this.doAssignments) {
            return;
         }

         const selectedAssignableVendors = this.unassignedList.filter((vendor) =>
            this.canAssignVendor(vendor)
         );
         if (!selectedAssignableVendors.length) {
            return;
         }

         this.doAssignments = true;
         try {
            const assignments = selectedAssignableVendors.flatMap((assignment) => {
               if (assignment.vendor) {
                  return assignment.iterators.map(({lower, upper, id}) => {
                     const currentPeriod = this.openStudyPeriods.find(
                        (period) => period.period.lower === lower && period.period.upper === upper
                     );

                     return {
                        vendor: assignment.vendor,
                        assigneeId: this.selectedUser.id,
                        period: currentPeriod.period,
                        speriodId: currentPeriod.id,
                        account: assignment.account,
                        id: id,
                        location: assignment.location,
                        uploadFileId: assignment.uploadFileId,
                     };
                  });
               } else {
                  const manualId = assignment.contractorId ?? assignment.vendorId;

                  if (this.expenseType === 'employees') {
                     // Employees need one assignment record per period they exist on --
                     // unlike contractors/supplies/cloud, the backend does not auto-expand
                     // a single assignment across every study period for employees.
                     return this.employeeExistingPeriods(manualId).map((period) => ({
                        employeeId: manualId,
                        assigneeId: this.selectedUser.id,
                        speriodId: period.id,
                        account: null,
                        location: assignment.location,
                        uploadFileId: assignment.uploadFileId,
                     }));
                  }

                  return [
                     {
                        ...(this.expenseType === 'contractors'
                           ? {contractorId: manualId}
                           : {vendorId: manualId}),
                        assigneeId: this.selectedUser.id,
                        speriodId: this.setManualPeriod.id,
                        account: null,
                        location: assignment.location,
                        uploadFileId: assignment.uploadFileId,
                     },
                  ];
               }
            });

            await this.$store.dispatch(`${this.expenseType}/createAssignments`, {
               assignments,
               profileId: this.profile.id,
            });

            await this.reloadAssignmentState();

            this.unassignedList = [];
            this.assignedList = this.syncSelectionWithVisibleSet(
               this.assignedList,
               this.filteredAssignedVendorSets
            );
         } finally {
            this.doAssignments = false;
         }
      },

      async fetchData() {
         // If the company has no active study or the year is outside the current study, redirect to company detail
         // TODO: this should be a watch on study change
         if (!this.hasOpenStudy) {
            this.$router.push({name: 'company-detail', params: {id: this.companyId}});
         }

         await this.$store.dispatch('users/loadCompanyUsers', {companyId: this.companyId});
         await this.$store.dispatch('companies/loadCompany', {
            companyId: this.companyId,
            detail: true,
            force: false,
         });

         this.loaded = true;
      },

      /** Submit a request to unassign an employee */
      async unassignVendors() {
         const assignments = this.assignedList.flatMap((assignment) => {
            if (assignment.vendor) {
               return assignment.iterators.map(({lower, upper, id}) => {
                  const currentPeriod = this.openStudyPeriods.find(
                     (period) => period.period.lower === lower && period.period.upper === upper
                  );

                  return {
                     companyId: this.companyId,
                     studyId: this.activeStudyId,
                     period: currentPeriod.period,
                     speriodId: currentPeriod.id,
                     vendor: assignment.vendor,
                     assigneeId: this.selectedUser.id,
                     account: assignment.account,
                     id: id,
                     location: assignment.location,
                     uploadFileId: assignment.uploadFileId,
                  };
               });
            } else {
               const manualId = assignment.contractorId ?? assignment.vendorId;

               if (this.expenseType === 'employees') {
                  return this.employeeExistingPeriods(manualId).map((period) => ({
                     companyId: this.companyId,
                     studyId: this.activeStudyId,
                     period: period.period,
                     speriodId: period.id,
                     employeeId: manualId,
                     assigneeId: this.selectedUser.id,
                     account: null,
                     location: assignment.location,
                     uploadFileId: assignment.uploadFileId,
                  }));
               }

               return [
                  {
                     companyId: this.companyId,
                     studyId: this.activeStudyId,
                     period: this.setManualPeriod.period,
                     speriodId: this.setManualPeriod.id,
                     ...(this.expenseType === 'contractors'
                        ? {contractorId: manualId}
                        : {vendorId: manualId}),
                     assigneeId: this.selectedUser.id,
                     account: null,
                     location: assignment.location,
                     uploadFileId: assignment.uploadFileId,
                  },
               ];
            }
         });

         await this.$store.dispatch(`${this.expenseType}/removeAssignments`, {
            assignments,
            profileId: this.profile.id,
         });

         await this.reloadAssignmentState();

         this.assignedList = [];
         this.unassignedList = this.syncSelectionWithVisibleSet(
            this.unassignedList,
            this.filteredEligibleUnassignedVendorSets
         );
      },
   },
   watch: {
      filteredUnassignedVendorSets() {
         this.unassignedList = this.syncSelectionWithVisibleSet(
            this.unassignedList,
            this.filteredEligibleUnassignedVendorSets
         );
      },
      filteredAssignedVendorSets() {
         this.assignedList = this.syncSelectionWithVisibleSet(
            this.assignedList,
            this.filteredEligibleAssignedVendorSets
         );
      },
   },
   async mounted() {
      await this.fetchData();
   },
};
</script>

<style scoped>
.input-group-text {
   background-color: white;
   color: grey;
}

::v-deep .modal-header {
   border-bottom: none !important;
   padding-bottom: 0 !important;
}

::v-deep .modal-footer {
   border-top: none !important;
}

::v-deep .modal-dialog {
   max-width: 80%;
}
::v-deep .modal-dialog {
   @media (max-width: 992px) {
      max-width: 90%;
   }
}

.custom-body {
   height: 300px;
   overflow-y: auto;
}

.vendor-row {
   height: 50px;
   display: flex;
   flex-direction: row;
   border-top: 1px solid lightgray;
   padding: 5px 10px;
   align-items: center;
   gap: 15px;
   cursor: pointer;
}

.vendor-row-disabled {
   opacity: 0.6;
}

.vendor-lock-note {
   color: #8a6d3b;
   font-size: 12px;
}

.permission-warning-alert {
   font-size: 12px;
   line-height: 1.4;
}

.footer-full-width-line {
   margin-left: -2.5rem; /* same as modal content padding */
   margin-right: -2.5rem;
   border: none;
   border-top: 1px solid #ccc;
   margin-bottom: 0;
   margin-top: 0;
}
.modal-subtitle {
   padding-top: 10px;
   font-size: 14px;
   font-weight: 300;
   color: black;
   margin-right: 20px;
}

.my-custom-ok-btn {
   padding: 5px 35px;
   font-size: 14px !important;
   background-color: #1660a9 !important;
   border: 1px solid #1660a9;
   &:hover {
      background-color: #1660a9 !important;
      border: 1px solid #1660a9;
   }
}

.action-button {
   font-size: 12px;
   padding: 5px 20px;
   background-color: #0978cd;
}

.back-button {
   padding: 5px 30px;
   font-size: 14px !important;
   background-color: transparent !important;
   color: #1660a9 !important;

   &:hover {
      background-color: transparent !important;
      color: #1660a9 !important;
   }
}

.btn-disabled {
   background-color: #999 !important;
   border-color: #999 !important;
   &:hover {
      background-color: #999 !important;
      border-color: #999 !important;
   }
}

@keyframes blink {
   0%,
   80%,
   100% {
      opacity: 0;
   }
   40% {
      opacity: 1;
   }
}
</style>
